// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

// auth
import {SIZE} from '../components';

// shared
import HighSchoolStudent from '-!svg-react-loader!shared/img/hs-student.svg';
import CommunityCollegeStudent from '-!svg-react-loader!shared/img/cc-student.svg';
import Educator from '-!svg-react-loader!shared/img/educator.svg';
import ParentOrGuardian from '-!svg-react-loader!shared/img/parent-guardian.svg';

export default class UserSelection extends React.Component {
  static propTypes = {
    setNavigationAnnouncement: PropTypes.func.isRequired,
    saveUrlParameters: PropTypes.func.isRequired,
    ccSelectionGroupUrl: PropTypes.string.isRequired
  }


  componentDidMount() {
    this.props.setNavigationAnnouncement('Sign Up - User Selection');
    this.props.saveUrlParameters();
  }

  render() {
    const {ccSelectionGroupUrl} = this.props;
    return (
      <React.Fragment>
        <h1 className="auth-signup-header">Tell us about yourself.</h1>
        <Link to="/signup/hs-student" className="auth-signup-user-link">
          <HighSchoolStudent width={SIZE} height={SIZE} /> I&#39;m a high school student
        </Link>
        <Link to={ccSelectionGroupUrl} className="auth-signup-user-link">
          <CommunityCollegeStudent width={SIZE} height={SIZE} /> I&#39;m a community college student
        </Link>
        <Link to="/signup/educator" className="auth-signup-user-link">
          <Educator width={SIZE} height={SIZE} /> I&#39;m an educator
        </Link>
        <Link to="/signup/parent" className="auth-signup-user-link">
          <ParentOrGuardian width={SIZE} height={SIZE} /> I&#39;m a parent or guardian
        </Link>
        <a
          href="https://help.raise.me/hc/en-us/articles/115001992367-Is-RaiseMe-only-for-high-school-students"
          className="auth-shared-link center"
        >I&#39;m none of these
        </a>
      </React.Fragment>
    );
  }
}
